import Vue from "vue";
import VueCookie from "vue-cookie";
import VueI18n from "vue-i18n";

/** element-ui **/
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import MyDatePicker from '@/components/date-picker'//自定义element ui date-picker
// Vue.use(MyDatePicker)
import locale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import zhTWlocale from "element-ui/lib/locale/lang/zh-TW"; //繁中
import zhLocale from "element-ui/lib/locale/lang/zh-CN"; //简中
/** /element-ui  **/

/** 自定义 - i18n **/
import en from "./en.json";
import zh_traditional from "./zh_tw.json"; //繁中
import zh_simplified from "./zh.json"; //简中//require("./zh.json"),

Vue.use(VueI18n) // 这里一行是必须加的。
// 在该js文件中，单独注册一个i18n实例并引入语言文件
const messages = {
  "zh-tw": {
    ...zh_traditional,
    ...zhTWlocale
  },
  "en": {
    ...en,
    ...enLocale
  }
}
// const lang = 'en';;
const lang = VueCookie.get('CardLang') || 'en';
const i18n = new VueI18n({
  messages,
  fallbackLocale: "en", // 匹配不到时默认的语言
  locale: lang,
})
locale.i18n((key, value) => i18n.t(key, value))

// 非 vue 文件中使用这个方法
const translate = (localeKey) => {
  const locale = VueCookie.get('CardLang') || 'en';
  const hasKey = i18n.te(localeKey, locale)  // 使用i18n的 te 方法来检查是否能够匹配到对应键值
  const translatedStr = i18n.t(localeKey)
  if (hasKey) {
    return translatedStr
  }
  return false
}
export { i18n, messages, translate }


// WEBPACK FOOTER //
// ./src/common/lang/vue-i18n.js